var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounQuestion3407992(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.477,
    height: 14.601,
    viewBox: "0 0 27.477 14.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-question-3407992",
    transform: "translate(-83.615 -138.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M91.874,321.077a2.384,2.384,0,0,0-2.342-1.85.412.412,0,0,0-.347.173l-.925,1.33a.3.3,0,0,1-.491,0l-.925-1.33a.325.325,0,0,0-.318-.2,2.414,2.414,0,0,0-2.342,1.85l-.549,2.371a.864.864,0,0,0,.838,1.041h7.112a.852.852,0,0,0,.838-1.041Z",
    transform: "translate(0 -171.539)",
    fill: "#0f70b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M127.7,212.1a2.258,2.258,0,0,0,2.255-2.255V208.9a2.255,2.255,0,0,0-4.51,0v.954A2.258,2.258,0,0,0,127.7,212.1Z",
    transform: "translate(-39.666 -64.793)",
    fill: "#0f70b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M454.156,323.449l-.549-2.371a2.384,2.384,0,0,0-2.342-1.85.412.412,0,0,0-.347.173l-.925,1.33a.3.3,0,0,1-.491,0l-.925-1.33a.287.287,0,0,0-.289-.2,2.414,2.414,0,0,0-2.342,1.85l-.549,2.371a.864.864,0,0,0,.838,1.041h7.112a.811.811,0,0,0,.809-1.012Z",
    transform: "translate(-343.085 -171.541)",
    fill: "#0f70b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M489.444,212.1a2.258,2.258,0,0,0,2.255-2.255V208.9a2.255,2.255,0,1,0-4.51,0v.954A2.24,2.24,0,0,0,489.444,212.1Z",
    transform: "translate(-382.739 -64.793)",
    fill: "#0f70b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M242.741,158.064a3.463,3.463,0,0,0-.954-.145,3.035,3.035,0,0,0-3.036,3.036,2.982,2.982,0,0,0,.491,1.648l-.549,1.214a.192.192,0,0,0,.26.26l1.214-.549a2.912,2.912,0,0,0,1.648.491,3.03,3.03,0,0,0,1.532-.4,4.49,4.49,0,0,1-1.272-3.122,4.259,4.259,0,0,1,.665-2.428Z",
    transform: "translate(-147.051 -18.587)",
    fill: "#0f70b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M330.262,145.143l-.636-1.388a3.59,3.59,0,0,0,.549-1.908,3.527,3.527,0,1,0-3.527,3.527,3.59,3.59,0,0,0,1.908-.549l1.388.636a.242.242,0,0,0,.318-.318Zm-3.614-.925a.52.52,0,1,1,.52-.52A.559.559,0,0,1,326.648,144.218Zm.607-2.082c-.231.2-.231.289-.231.347v.173a.187.187,0,0,1-.173.173h-.463a.187.187,0,0,1-.173-.173v-.2a1.2,1.2,0,0,1,.549-.954c.26-.2.52-.463.52-.694,0-.347-.173-.491-.578-.491-.636,0-.636.463-.636.491v.087a.187.187,0,0,1-.173.173h-.463a.187.187,0,0,1-.173-.173v-.087a1.327,1.327,0,0,1,1.446-1.3,1.25,1.25,0,0,1,1.388,1.3,1.834,1.834,0,0,1-.838,1.33Z",
    transform: "translate(-227.141)",
    fill: "#0f70b6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounQuestion3407992);
export default __webpack_public_path__ + "static/media/noun-question-3407992.a467677e3e3065317b4b3930020adccc.svg";
export { ForwardRef as ReactComponent };